import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  createShape,
  fetchAllShapes,
  updateShape,
  fetchOneShape,
  deleteShape,
} from "services/shape";

// Fetch all shapes with optional filtering
export const useAllShapes = (filters = {}, enabled = true) => {
  return useQuery({
    queryKey: ["shapes", filters],
    queryFn: () => fetchAllShapes(filters),
    enabled,
  });
};

// Fetch single shape by ID
export const useOneShape = (id, enabled = true) => {
  return useQuery({
    queryKey: ["shape", id],
    queryFn: () => fetchOneShape(id),
    enabled: Boolean(id) && enabled,
  });
};

// Create new shape
export const useCreateShape = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data) => createShape(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["shapes"] });
    },
  });
};

// Update existing shape
export const useUpdateShape = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }) => updateShape(data, id),
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: ["shapes"] });
      queryClient.invalidateQueries({ queryKey: ["shape", variables.id] });
    },
  });
};

// Delete shape
export const useDeleteShape = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id) => deleteShape(id),
    onSuccess: (data, id) => {
      queryClient.invalidateQueries({ queryKey: ["shapes"] });
      queryClient.invalidateQueries({ queryKey: ["shape", id] });
    },
  });
};
